module.exports = __webpack_public_path__ + "media/8.ca745da5.wav";